

// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import {
    walletNotificationStatuses,
    walletNotificationChannels,
    walletNotificationCategories,
    walletNotificationNames
} from '../statuses';

export default class WalletNotificationsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'wallet-notifications';
        this.Server = this.props.context.getState().server.walletNotifications;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['notificationName'];

        const defaultHead = [
            {
                id: 'userId',
                label: 'user',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'walletUsers',
                object: 'user',
                show: 'email'
            },
            {
                id: 'notificationName',
                label: 'notificationName',
                alignRight: false,
                cell: 'Items',
                displayGrid: true,
                items: Object.values(walletNotificationNames),
                disableEditor: true
            },
            {
                id: 'category',
                label: 'category',
                alignRight: false,
                cell: 'Items',
                displayGrid: true,
                items: Object.values(walletNotificationCategories),
                disableEditor: true
            },
            {
                id: 'notificationData',
                label: 'notificationData',
                alignRight: false,
                cell: 'Json',
                displayGrid: false,
                disableEditor: true,
                displayDialogDetails: true,
                details: 'Json'
            },
            {
                id: 'status',
                label: 'status',
                alignRight: false,
                cell: 'Items',
                displayGrid: true,
                items: Object.values(walletNotificationStatuses)
            },
            {
                id: 'requestedChannels',
                label: 'requestedChannels',
                alignRight: false,
                cell: 'StaticMultiSelect',
                items: Object.values(walletNotificationChannels),
                displayGrid: true,
                displayDialogDetails: true,
                details: 'Array',
                display: 'comma'
            },
            {
                id: 'sentChannels',
                label: 'sentChannels',
                alignRight: false,
                cell: 'StaticMultiSelect',
                items: Object.values(walletNotificationChannels),
                displayGrid: true,
                displayDialogDetails: true,
                details: 'Array',
                display: 'comma'
            },
            {
                id: 'attempts',
                label: 'attempts',
                alignRight: true,
                cell: 'Number',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'lastAttemptAt',
                label: 'lastAttemptAt',
                alignRight: false,
                cell: 'DateTime',
                displayGrid: false,
                displayDialogDetails: true,
                disableEditor: true
            },
            {
                id: 'nextAttemptAt',
                label: 'nextAttemptAt',
                alignRight: false,
                cell: 'DateTime',
                displayGrid: false,
                displayDialogDetails: true,
                disableEditor: true
            },
            {
                id: 'lastError',
                label: 'lastError',
                alignRight: false,
                cell: 'BigText',
                displayGrid: false,
                displayDialogDetails: true,
                disableEditor: true
            },
            {
                id: 'broadcastId',
                label: 'broadcastId',
                alignRight: false,
                cell: 'Text',
                displayGrid: false,
                displayDialogDetails: true,
                disableEditor: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

